import * as signalR from '@microsoft/signalr';
import { HubConnection, LogLevel } from '@microsoft/signalr';
import { useDispatch } from 'react-redux';

import { setIsSocketConnected } from 'store/ticket-service/ticketSlice';

import { VaultService } from 'utils/storage';

import { getDevOrProdUrl } from 'core/helpers/get-dev-or-prod-url';
import { ISocketConnectionData } from 'core/types/base';

const usePaymentStream = () => {
	const dispatch = useDispatch();

	const storage = new VaultService();
	const TOKEN = storage.getItem('token');

	const openConnection = (token?: string): Promise<ISocketConnectionData> => {
		return new Promise((resolve) => {
			localStorage.setItem('connectionId', '');
			window.dispatchEvent(new Event('connectionId'));
			const connection = new signalR.HubConnectionBuilder()
				.withUrl(getDevOrProdUrl('dev/paymentHub', 'paymentHub'), {
					headers: {
						Authorization: `bearer ${TOKEN || token}`,
					},
					transport: signalR.HttpTransportType.LongPolling,
				})
				.withAutomaticReconnect()
				.configureLogging(LogLevel.None)
				.build();

			connection
				.start()
				.then(() => {
					dispatch(setIsSocketConnected(true));
				})
				.catch((error) => {
					console.error(error);
				});

			// return connection object that can be used to subscribe to events and connection id

			connection.on('onConnected', function (connectionId) {
				localStorage.setItem('connectionId', connectionId);
				window.dispatchEvent(new Event('connectionId'));

				resolve({
					connection,
					connectionId,
				});
			});
		});
	};

	// close connection accepts connection object returned from openConnection as argument

	const closeConnection = (connectionInstance: HubConnection) => {
		connectionInstance
			.stop()
			.then(() => {
				dispatch(setIsSocketConnected(false));
			})
			.catch((error) => {
				console.error(error);
			});
	};

	return { openConnection, closeConnection };
};

export default usePaymentStream;
